export default "__VITE_ASSET__c7946123__"